import moment from 'moment';
import { ACITONCOPYRIGHT } from '../../../actionTypes';
export function getCAPTCHA(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_COPYRIGHT_CAPTCHA,
		payload,
		callback,
		errorCallback
	};
}
export function bindPhone(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.COPYRIGHT_BIND_PHONE,
		payload,
		callback,
		errorCallback
	};
}
export function bindPhone_PC(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.COPYRIGHT_BIND_PHONE_PC,
		payload,
		callback,
		errorCallback
	};
}
export function getWxInfo(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.COPYRIGHT_GET_WXINFO,
		payload,
		callback,
		errorCallback
	};
}
